<template>
	<div class="phone_home_main">
		<div class="phone_bg">
			<img src="../assets/home_bg.jpg"/>
		</div>
		<div class="swiper-container">
	    <div class="swiper-wrapper">
	      <div class="swiper-slide"><router-link class="home-link" to="company-profile"><img src="../assets/logo_first.png" alt=""></router-link></div>
	      <div class="swiper-slide"><router-link class="home-link" to="ayo-about"><img src="../assets/ayo_icon.png" alt=""></router-link></div>
	      <div class="swiper-slide"><router-link class="home-link" to="afsc-about"><img src="../assets/afsc_icon_2.png" alt=""></router-link></div>
	    </div>
	    <!-- Add Pagination -->
	    <div class="swiper-pagination"></div>
	    <div id="swiper-pagination1" class="swiper-pagination_1"></div>
	 </div>
		<div class="home_footer">
			<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有<br />©2016【 沪ICP备16032276号 】</p>
	    <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved<br />©2016[Shanghai ICP no. 16032276]</p>
	    <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	    <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
		</div>
	</div>
</template>

<script>
//	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	
	export default {
  	props:["lang"],
	  data () {
	    return {
	      msg: '11'
	    }
	  },
	  methods: {
	  	
	  },
	  mounted () {
	  	if(document.getElementById('phoneayo_icon')) {
	  		document.getElementById('phoneayo_icon').style.display = "inline-block";
		    document.getElementById('phoneayo_icon_2').style.display = "none";
		    document.getElementById('phoneafsc_icon').style.display = "inline-block";
		    document.getElementById('phoneafsc_icon_2').style.display = "none";
	  	}
	  	
			var swiper = new Swiper('.swiper-container', {
	      autoplay: {
	        delay: 4000,
	        disableOnInteraction: false
	      },
	      loop: true,
	      pagination: {
	        el: '.swiper-pagination',
	      },
	      on: {
	        init: function() {
	          console.log(this)
	          // var len = swiper.slides.length;
	          var sp = document.getElementById('swiper-pagination1');
	          var html =[];
	          let template = `<div id="phone-item" class="phone-item">01</div><div>/</div><div>03</div>`;
            html.push(template)
            sp.innerHTML = html.join('')
//	          var list = document.getElementsByClassName('pa-item');
//	          list[0].classList.add("pa-item-active");
	        },
	        slideChangeTransitionStart: function() {
	          // console.log(this.activeIndex);
	          var item_lists = document.getElementsByClassName('pa-item');
	          switch (this.activeIndex) {
	            case 0:
	            	if ( document.getElementById("phone-item") ) {
	              	document.getElementById("phone-item").innerHTML = "03"
	            	}
	              break;
	            case 1:
	            	if ( document.getElementById("phone-item") ) {
	              	document.getElementById("phone-item").innerHTML = "01"	
	            	}
	              break;
	            case 2:
	              if ( document.getElementById("phone-item") ) {
	              	document.getElementById("phone-item").innerHTML = "02"
	            	}
	              break;
	            case 3:
	              if ( document.getElementById("phone-item") ) {
	              	document.getElementById("phone-item").innerHTML = "03"
	            	}
	              break;
	            case 4:
	              if ( document.getElementById("phone-item") ) {
	              	document.getElementById("phone-item").innerHTML = "01"
	            	}
	              break;
	          }
	        }
	      }
	    });
	  }
	}
</script>

<style lang="less" scoped>
	
	.phone_bg {
		width: 100%;
		background-color: #FFFB00;
		img {
			width: 100%;
		}
	}

	.home_footer {
		width: 100%;
		background-color: #FFFB00;
		padding: 2rem 0rem 2rem 0rem ;
		p {
			width: 96%;
			margin: 0 auto;
			color: #000000;
			font-family: Regular;
			font-size: .8rem;
			text-align: center;
		}
	}
  
  .swiper-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: transparent;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    img {
    	width: 60%;
    }
  }
  
  
</style>


// WEBPACK FOOTER //
// src/components/phone_home.vue